import { createSlice } from "@reduxjs/toolkit";

import { activateSeoMission, createSeoMissions, declineSeoMission, deleteSeoMission, getCompleteSeoMission, getDeclinedSeoMission, getSeoMissions } from "./thunks";
import {
    seoMissionsState
} from "./types";
const initialLoadingState = {
    ["seoMissions/create"]: "idle",
    ["seoMissions/get"]: "idle",
    ["seoMissions/getCompleted"]: "idle",
    ["seoMissions/decline"]: "idle",
    ["seoMissions/getDeclined"]: "idle",
    ["seoMissions/delete"]: "idle",
    ["seoMissions/activate"]: "idle",


};



const initialState = {
    entities: [],
    completedEntities: [],

    completedLimit: 25,
    completedPage: 0,
    completedTotal: 0,
    declinedEntities: [],
    declinedLimit: 25,
    declinedPage: 0,
    declinedTotal: 0,


    limit: 25,

    page: 0,
    total: 0,
    loading: initialLoadingState,
    error: null,
    message: { type: "", message: "", requestType: "" },
    fulfilled: false,
} as seoMissionsState;


const seoMissionsSlice = createSlice({
    name: "seoMissions",
    initialState,
    reducers: {
        resetSeoMissionsState: (state) => {
            state = initialState;
        },
        resetSeoMissionsMessageState: (state) => {
            state.message = { type: "", message: "", requestType: "" };
        }
    },
    extraReducers: (builder) => {
        builder.addCase(createSeoMissions.pending, (state) => {
            state.loading["seoMissions/create"] = "pending";
        });
        builder.addCase(createSeoMissions.fulfilled, (state, action) => {
            state.loading["seoMissions/create"] = "finished";
            state.entities.push(action.payload);
            state.fulfilled = true;
            state.message = {
                type: "success",
                message: "SEO Mission created successfully",
                requestType: "create",
            };
        });
        builder.addCase(createSeoMissions.rejected, (state, action) => {
            state.loading["seoMissions/create"] = "finished";
            state.error = action.error.message;
            state.message = {
                type: "error",
                message: "Failed to create SEO Mission",
                requestType: "create",
            };
        });

        builder.addCase(getSeoMissions.pending, (state) => {
            state.loading["seoMissions/get"] = "pending";
        }
        );
        builder.addCase(getSeoMissions.fulfilled, (state, action) => {
            state.loading["seoMissions/get"] = "finished";


            state.entities = action.payload.seoMissionsData;
            state.total = action.payload.total;
            state.page++;
            state.limit = action.payload.limit;
            state.fulfilled = true;
            state.message = { type: "success", message: "SEO Missions fetched successfully", requestType: "get" };
        });
        builder.addCase(getSeoMissions.rejected, (state, action) => {
            state.loading["seoMissions/get"] = "finished";
            state.error = action.error.message;
        });
        builder.addCase(getCompleteSeoMission.pending, (state) => {
            state.loading["seoMissions/getCompleted"] = "pending";
        }
        );
        builder.addCase(getCompleteSeoMission.fulfilled, (state, action) => {
            state.loading["seoMissions/getCompleted"] = "finished";
            state.completedEntities = action.payload.seoMissionsData;
            state.completedTotal = action.payload.total;
            state.completedPage++;
            state.completedLimit = action.payload.limit;
            state.fulfilled = true;
            state.message = { type: "success", message: "Completed SEO Missions fetched successfully", requestType: "get" };
        });
        builder.addCase(getCompleteSeoMission.rejected, (state, action) => {
            state.loading["seoMissions/getCompleted"] = "finished";
            state.error = action.error.message;
        });

        builder.addCase(declineSeoMission.pending, (state) => {
            state.loading["seoMissions/decline"] = "pending";
        }
        );
        builder.addCase(declineSeoMission.fulfilled, (state, action) => {
            state.loading["seoMissions/decline"] = "finished";
            state.entities = state.entities.filter((entity) => entity.id !== action.payload.id);
            const index = state.entities.findIndex((entity) => entity.id === action
                .payload.id);
            if (index !== -1) {
                state.entities.splice(index, 1);
            }

            state.fulfilled = true;
            state.message = { type: "success", message: "SEO Mission declined successfully", requestType: "decline" };
        });
        builder.addCase(declineSeoMission.rejected, (state, action) => {
            state.loading["seoMissions/decline"] = "finished";
            state.error = action.error.message;
            state.message = { type: "error", message: "Failed to decline SEO Mission", requestType: "decline" };
        });

        builder.addCase(getDeclinedSeoMission.pending, (state) => {
            state.loading["seoMissions/getDeclined"] = "pending";
        }
        );
        builder.addCase(getDeclinedSeoMission.fulfilled, (state, action) => {
            state.loading["seoMissions/getDeclined"] = "finished";
            state.declinedEntities = action.payload.seoMissionsData;
            state.declinedTotal = action.payload.total;
            state.declinedPage++;
            state.declinedLimit = action.payload.limit;
            state.fulfilled = true;
            state.message = { type: "success", message: "Declined SEO Missions fetched successfully", requestType: "get" };
        });
        builder.addCase(getDeclinedSeoMission.rejected, (state, action) => {
            state.loading["seoMissions/getDeclined"] = "finished";
            state.error = action.error.message;
        });


        //delete SEO mission
        builder.addCase(deleteSeoMission.pending, (state) => {
            state.loading["seoMissions/delete"] = "pending";
        });
        builder.addCase(deleteSeoMission.fulfilled, (state, action) => {
            state.loading["seoMissions/delete"] = "finished";
            state.declinedEntities = state.declinedEntities.filter((entity) => entity.id !== action.payload.id);
            const index = state.declinedEntities.findIndex((entity) => entity.id === action.payload.id);

            if (index !== -1) {
                state.declinedEntities.splice(index, 1);
            }
            state.fulfilled = true;
            state.message = { type: "success", message: "SEO Mission deleted successfully", requestType: "delete" };
        }
        );
        builder.addCase(deleteSeoMission.rejected, (state, action) => {
            state.loading["seoMissions/delete"] = "finished";
            state.error = action.error.message;
            state.message = { type: "error", message: "Failed to delete SEO Mission", requestType: "delete" };
        });

        //activate SEO mission
        builder.addCase(activateSeoMission.pending, (state) => {
            state.loading["seoMissions/activate"] = "pending";
        });

        builder.addCase(activateSeoMission.fulfilled, (state, action) => {
            state.loading["seoMissions/activate"] = "finished";
            state.declinedEntities = state.declinedEntities.filter((entity) => entity.id !== action.payload.id);
            const index = state.declinedEntities.findIndex((entity) => entity.id === action.payload.id);
            if (index !== -1) {
                state.declinedEntities.splice(index, 1);
            }
            state.fulfilled = true;
            state.message = { type: "success", message: "SEO Mission activated successfully", requestType: "activate" };
        }
        );
        builder.addCase(activateSeoMission.rejected, (state, action) => {
            state.loading["seoMissions/activate"] = "finished";
            state.error = action.error.message;
            state.message = { type: "error", message: "Failed to activate SEO Mission", requestType: "activate" };
        });

    },
});


export const { resetSeoMissionsState, resetSeoMissionsMessageState } = seoMissionsSlice.actions;
export * from "./selectors";
export * from "./thunks";
export * from "./types";

export default seoMissionsSlice.reducer;